const { $, jQuery, WOW } = window

window.jqueryOnReady = function () {
  
  "use strict";

  //$(".preeloader").fadeIn();

  /*--------------------------
      STICKY MAINMENU
  ---------------------------*/
  $("#mainmenu-area").sticky({
      topSpacing: 0
  });


  /*---------------------------
      SMOOTH SCROLL
  -----------------------------*/
  $('a.navbar-brand, a.scrolltotop').on('click', function (event) {
      var id = $(this).attr("href");
      //var target = $(id).offset().top - offset;
      $('html, body').animate({
          scrollTop: 29
      }, 1500, "easeInOutExpo");
      event.preventDefault();
  });


  /*---------------------------
      Navbar SCROLL
  -----------------------------*/

  $('ul#nav li a[href^="#"]').on('click', function (event) {
    var id = $(this).attr("href");

    var elementToScroll = $(id.replace('\/', ''))

    if(elementToScroll.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: $(id.replace('\/', '')).offset().top - 60
      }, 1500, "easeInOutExpo");
      if($('#nav').css('display') && $('.stellarnav.dark.mobile').length) {
            $('#nav').css('display', 'none')
      }
    }
    
});


  /*----------------------------
      MOBILE & DROPDOWN MENU
  ------------------------------*/
  jQuery('.stellarnav').stellarNav({
      theme: 'dark'
  });

  /*----------------------------
      SCROLL TO TOP
  ------------------------------*/
  $(window).scroll(function () {
      var totalHeight = $(window).scrollTop();
      if (totalHeight > 300) {
          $(".scrolltotop").fadeIn();
      } else {
          $(".scrolltotop").fadeOut();
      }
  });


  /*--------------------------
     HOME PARALLAX BACKGROUND
  ----------------------------*/
  $(window).stellar({
      responsive: true,
      positionProperty: 'position',
      horizontalScrolling: false
  });

  /*----------------------------
      TAB PANEL ACTIVE
  ------------------------------*/
  $('.panel').on('click', function (e) {
      $('.panel').removeClass('active');
      var $this = $(this);
      if (!$this.hasClass('active')) {
          $this.addClass('active');
      }
      e.preventDefault();
  });

  
  $('#clients-link > div > div:nth-child(2) > div > ul > li:nth-child(1)').first().addClass('active')
  $('#despachante').addClass('active in')

  window.scrollTo(0, 0)

  new WOW({
    boxClass:     'wow',      // default
    animateClass: 'animated', // default
    offset:       0,          // default
    mobile:       true,       // default
    live:         true        // default
  }).init();

  $(".preeloader").fadeOut(500);

}